let io = null;

const intersect = {

  bind: function (el) {
    el.style.visibility = 'hidden';
  },

  inserted: function (el, binding) {
    io = new IntersectionObserver(entries => {
      entries.forEach(({isIntersecting}) => {
        if (!isIntersecting) {
          return;
        }
        if (binding.value && binding.value.class && binding.value.class.length > 0) {
          const classArr = binding.value.class.split(' ');
          classArr.forEach(item => {
            el.classList.add(item);
          })
        }
        el.style.visibility = 'visible';
        io.unobserve(el);
      })
    }, {
      threshold: 0.25,
    });
    if (binding.value && binding.value.class && !el.classList.contains(binding.value.class)) {
      io.observe(el);
    }
  },

  unbind: function (el) {
    if (el.style.visibility && el.style.visibility === 'hidden') {
      io.unobserve(el);
    }
  }
};

export default intersect;



// WEBPACK FOOTER //
// ./src/directives/intersect.js